import { useTranslation } from "@redotech/redo-i18n";
import { FlowType } from "@redotech/redo-return-core-common/return-flow-enums";
import type { FulfillmentWithinState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const FulfillmentWithinDetails = memo(function FulfillmentWithinDetails({
  state,
  setState,
  disabled,
  flowType,
}: ConditionTypeDetailsProps<FulfillmentWithinState>) {
  const { t } = useTranslation();
  return (
    <Flex dir="column" gap="xs">
      <Text fontSize="xs" fontWeight="medium" textColor="secondary">
        {t("Max days")}
      </Text>
      <RedoTextInput
        min={0}
        placeholder={t("Enter number of days...")}
        setValue={setState}
        state={disabled ? "readonly" : "default"}
        value={state}
      />
      {(flowType === FlowType.FINALIZE_RETURN ||
        flowType === FlowType.FINALIZE_CLAIM) && (
        <Text fontSize="xxs" fontWeight="regular" textColor="secondary">
          {t(
            "If any selected item was not fulfilled within this number of days, the condition will not match",
          )}
        </Text>
      )}
    </Flex>
  );
});
